<template>
    <div>
        <button @click="toggleDropdown()" type="button" class="pro-nav__link" :class="{ 'pro-nav__link--active': isVisible }">
            {{ label }}<ProIcon icon="arrow-down" />
        </button>
        <transition :name="transition" v-on:enter="onEnter">
            <div v-show="isVisible" class="pro-nav__dropdown" ref="content">
                <ul v-for="(list, i) in lists" :key="i" class="pro-nav__dropdown-section">
                    <li class="pro-nav__dropdown-heading">{{ list.label }}</li>
                    <li class="pro-nav__dropdown-section-item">
                        <ul class="pro-nav__dropdown-list">
                            <li v-for="(item, x) in list.items" :key="x" class="pro-nav__dropdown-list-item">
                                <ProLink
                                    class="pro-nav__dropdown-link"
                                    :href="item.href ? item.href : null"
                                    :to="item.name ? { name: item.name } : null"
                                    :target="item.external ? '_blank' : null"
                                >
                                    <span class="pro-nav__dropdown-link-title">{{ item.title }} <ProIcon v-if="item.external" icon="external" /></span>
                                    <span class="pro-nav__dropdown-link-description" v-if="item.description">{{ item.description }}</span>
                                </ProLink>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        lists: {
            type: Array,
            default: null,
        },
        order: {
            type: Number,
            default: 0,
        },
    },

    data: () => {
        return {
            open: false,
            transition: "pro-nav-dropdown-fade",
        };
    },

    methods: {
        toggleDropdown() {
            this.open = !this.open;

            if (this.open) {
                this.$store.dispatch("navigation/openDropdown", { order: this.order });
                document.addEventListener("click", this.handleFocus);
            } else {
                this.$store.dispatch("navigation/closeDropdown");
                document.removeEventListener("click", this.handleFocus);
            }
        },

        onEnter() {
            const offsetRight = this.$el.offsetParent.offsetWidth - this.$el.offsetLeft - this.$el.offsetWidth / 2;
            this.$store.commit("navigation/setOffset", offsetRight);
            this.$store.commit("navigation/setHeight", this.$refs.content.offsetHeight);
        },

        handleFocus(e) {
            const focusInside = this.$el.contains(e.target);
            if (!focusInside && this.open) {
                this.toggleDropdown();
            }
        },
    },

    computed: {
        ...mapGetters({
            activeOrder: "navigation/getOrder",
            isActive: "navigation/getIsActive",
        }),
        isVisible() {
            return this.open && this.isActive;
        },
    },

    watch: {
        $route() {
            if (this.open) {
                this.toggleDropdown();
            }
        },
        activeOrder(next, last) {
            const getTranstion = () => {
                if (next == last) return "pro-nav-dropdown-fade";
                if (next > last) return "pro-nav-dropdown-fade-right";
                if (next < last) return "pro-nav-dropdown-fade-left";
            };

            this.transition = getTranstion();
        },
        isActive() {
            this.transition = "pro-nav-dropdown-fade";
        },
    },
};
</script>
